<template>
  <div>
    <page-heading title="Currently ClockedIn"></page-heading>
    <el-row :gutter="20">
      <el-col :span="24">
        <current-clockedin v-auth="['admin', 'manager']"></current-clockedin>
      </el-col>

    </el-row>
  </div>
</template>

<script>

  import CurrentClockedin from '@/components/CurrentClockedin';

  export default {
    name: 'CurrentClockedInPage',
    components: {
      currentClockedin: CurrentClockedin,
    },
    data() {
      return {
        translationPrefix: 'pages.dashboard',
      };
    },
  };
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/CurrentClockedIn.vue